import { SelectInputV2, SelectInputV2Props } from '@frontend/components/basic-forms';
import { OrderStatus, OrderStatusName } from '@frontend/order/types';

const ID = 'order-state-select';

export interface OrderStateSelectProps extends Omit<SelectInputV2Props<OrderStatusName>, 'options'> {
    states?: OrderStatusName[];
}

export const OrderStateSelect = ({ states, ...props }: OrderStateSelectProps) => {
    const availableStates = states ? OrderStatus.ALL.filter((state) => states.includes(state.name)) : OrderStatus.ALL;

    return (
        <SelectInputV2
            {...props}
            id={ID + props.id}
            label={props.label || 'Order state'}
            options={availableStates.map((state) => ({ value: state.name, label: state.name, display: state.display }))}
        />
    );
};

export default OrderStateSelect;
